<template>
  <div class="market-price-detail-modal-table">
    <template>
      <table class="table amt-table" style="width:100%">
        <thead>
        <tr>
          <th class="col-1">구매일</th>
          <th class="col-1">결제일</th>
          <th class="col-1">구분</th>
          <th class="col-4">내용</th>
          <th class="col-1">플랜</th>
          <th class="col-3">서비스 이용기간</th>
          <th class="col-1">금액</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(order, order_idx) in service.service_app_order" :key="`order-${order_idx}`">
          <td>{{ order.created_time? datesFormat(order.created_time, 'date_3'): '' }}</td>
          <td>{{ order.next_date? datesFormat(order.next_date, 'date_3'): '' }}</td>
          <td>{{ order.app_type==='package'? '플랫폼 팩':order.app_type==='plugin'? '플러그인':'추가서비스' }}</td>
          <td>{{ order.product.name }}</td>
          <td>{{ planType(order) }}</td>
          <td>{{ periodOrder(order) }}</td>
          <td>{{ order.subscribe_price * 10 / 11 | currency }}</td>
        </tr>
        </tbody>
      </table>

      <div class="flex-between" style="padding: 0 17px">
        <div>
          <span style="margin-right:8px">결제 수단</span>
          <span>{{ service.credit_card }}</span>
        </div>
        <div>
          <span style="font-weight:bold;color:#363636;">합계(부가세 포함)</span>
          <span style="margin-left:24px">{{ totalPrice | currency }}</span>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
  export default {
    props: {
      service: {
        type: Object
      }
    },
    name: "MarketPriceDetailModal",
    created() {

    },
    data() {
      return {}
    },
    computed: {
      totalPrice() {
        let price = 0;
        if (this.service.service_app_order.length > 0) {
          this.service.service_app_order.forEach(app_order => {
            price += app_order.subscribe_price;
          })
        }
        return price;
      }
    },
    methods: {
      planType(order) {
        if(order.app_type==='package') {
          return order.date_unit.toString() + '개월'
        } else {
          return order.is_subscription?'월결제':'건결제'
        }
      },
      periodOrder(order) {
        if(order.is_subscription) {
          return `${this.datesFormat(order.start_date, 'date_3')}~${this.datesFormat(order.end_date, 'date_3')}`
        } else {
          return `${this.datesFormat(order.start_date, 'date_3')}~`
        }
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .market-price-detail-modal-table tbody tr:last-child
    border-bottom 1px solid #000000
</style>
